import { useMemo } from "react";

import type { ListIteratee } from "lodash";
import { sortBy } from "lodash";

import useLatestValue from "app/custom-hooks/useLatestValue";

type HookParams<T> = {
    shouldProcess: boolean;
    collection: readonly T[];
    iteratee: ListIteratee<T>;
};

const useSortedDropdownItems = <T>({ shouldProcess, collection, iteratee }: HookParams<T>): readonly T[] => {
    const latestCollectionRef = useLatestValue(collection);
    const iterateeCbRef = useLatestValue(iteratee);

    const sortedCollection = useMemo((): readonly T[] | null => {
        if (!shouldProcess) {return null;}

        return sortBy(latestCollectionRef.current, iterateeCbRef.current);
    }, [shouldProcess]);

    return sortedCollection ?? collection;
};

export default useSortedDropdownItems;
